<template>
	<div class="home">
		<cartComponent />
	</div>
</template>

<script>
import cartComponent from "@/components/client/cartComponent.vue";
export default {
	name: "HomeView",
	components: {
		cartComponent,
	},
};
</script>
